import React, { Component } from 'react';

const setInitialState = (settings) => {
  const { itemHeight, amount, tolerance, minIndex, maxIndex, startIndex } = settings;
  const viewportHeight = amount * itemHeight;
  const totalHeight = (maxIndex - minIndex + 1) * itemHeight;
  const toleranceHeight = tolerance * itemHeight;
  const bufferHeight = viewportHeight + 2 * toleranceHeight;
  const bufferedItems = amount + 2 * tolerance;
  const itemsAbove = startIndex - tolerance - minIndex;
  const topPaddingHeight = itemsAbove * itemHeight;
  const bottomPaddingHeight = totalHeight - topPaddingHeight;
  const initialPosition = topPaddingHeight + toleranceHeight;
  return {
    settings,
    viewportHeight,
    totalHeight,
    toleranceHeight,
    bufferHeight,
    bufferedItems,
    topPaddingHeight,
    bottomPaddingHeight,
    initialPosition,
    data: [],
  };
};

class Scroller extends Component {
  constructor(props) {
    super(props);
    this.state = setInitialState(props.settings);
    this.viewportElement = React.createRef();
  }

  componentDidMount() {
    const { isFromFairness } = this.props;
    const className = isFromFairness ? '.from-fairness' : '.betslip-ticketsitem-list-wrapper';
    document.querySelector(className).addEventListener('scroll', this.runScroller);
    const { initialPosition } = this.state;
    this.viewportElement.current.scrollTop = initialPosition;
    if (!initialPosition) {
      this.runScroller({ target: { scrollTop: 0 } });
    }
  }

  componentDidUpdate(prevProps) {
    const { settings } = this.props;
    if (prevProps.settings.maxIndex !== settings.maxIndex) {
      const { maxIndex, minIndex, itemHeight } = settings;
      this.setState({ settings, totalHeight: (maxIndex - minIndex + 1) * itemHeight }, () => {
        this.runScroller({
          target: {
            scrollTop: document.querySelector('.betslip-ticketsitem-list-wrapper').scrollTop,
          },
        });
      });
    }
  }

  componentWillUnmount() {
    const { isFromFairness } = this.props;
    const className = isFromFairness ? '.from-fairness' : '.betslip-ticketsitem-list-wrapper';
    document.querySelector(className).removeEventListener('scroll', this.runScroller);
  }

  runScroller = ({ target: { scrollTop } }) => {
    const {
      totalHeight,
      toleranceHeight,
      bufferedItems,
      settings: { itemHeight, minIndex },
    } = this.state;
    const { get } = this.props;
    const index = minIndex + Math.floor((scrollTop - toleranceHeight) / itemHeight);
    const data = get(index, bufferedItems);
    const topPaddingHeight = Math.max((index - minIndex) * itemHeight, 0);
    const bottomPaddingHeight = Math.max(
      totalHeight - topPaddingHeight - data.length * itemHeight,
      0
    );
    this.setState({
      topPaddingHeight,
      bottomPaddingHeight,
      data,
    });
  };

  render() {
    const { topPaddingHeight, bottomPaddingHeight, data } = this.state;
    const { row, isFromFairness } = this.props;
    return (
      <div className={`betslip-ticketsitem-list-wrapper ${isFromFairness ? 'from-fairness' : ''}`}>
        <div className='betslip-ticketsitem-list' ref={this.viewportElement}>
          <div style={{ height: topPaddingHeight }} />
          {data.map(row)}
          <div style={{ height: bottomPaddingHeight }} />
        </div>
      </div>
    );
  }
}

export default Scroller;
